const StringUtils = require("../utils/StringUtils"),
  Constants = require("../constants/AppConstants");

var $ = require("jquery");

var moment = require("moment");
require("moment/locale/fr");
require("../utils/prototypes");

var Utils = {
  isMobile: function() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  },

  isIE9: function() {
    // return true;

    var isIE = navigator.appVersion.indexOf("MSIE") != -1;
    if (!isIE) {
      return false;
    }

    var version = parseFloat(navigator.appVersion.split("MSIE")[1]);
    return version <= 9;
  },

  isAndroid: function() {
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1;
    if (isAndroid) {
      return true;
    }
    return false;
  },

  downloadContract: function(idMission) {
    var url = "/c/" + idMission;
    window.open(url, "_newtab");
  },

  getCloudinaryConstants: function() {
    if (
      window.location.hostname == "medgo.fr" ||
      window.location.hostname == "www.medgo.fr" ||
      window.location.hostname == "medgobeta.herokuapp.com" ||
      window.location.hostname == "www.medgobeta.herokuapp.com"
    ) {
      return {
        upload_preset: "jdcoda0o",
        upload_url: "https://api.cloudinary.com/v1_1/medgo/upload",
        res_url: "https://res.cloudinary.com/medgo/image/upload"
      };
    } else {
      return {
        upload_preset: "bmkmvyab",
        upload_url: "https://api.cloudinary.com/v1_1/medgotest/upload",
        res_url: "https://res.cloudinary.com/medgotest/image/upload"
      };
    }
  },

  getCloudinarySignature: function(container, callback) {
    var constants = Utils.getCloudinaryConstants();
    if (!constants || !constants.upload_preset) {
      return;
    }
    Utils.csfrAjax({
      url: "/document/profilePictureSignature",
      dataType: "json",
      type: "GET",
      data: {
        upload_preset: constants.upload_preset
      },
      success: function(signature) {
        callback(signature);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  getCloudinaryDocumentSignature: async function(document) {
    var constants = Utils.getCloudinaryConstants();
    if (!constants || !constants.upload_preset) {
      return;
    }
    return Utils.request("/document/signatures", "GET", {
      upload_preset: constants.upload_preset,
      documentType: document
    });
  },

  getNextLimitDate: function(limit, date) {
    var limitDate = moment(date);
    limitDate.add(1, "month");
    limitDate.date(limit);
    limitDate.endOf("day");
    return limitDate;
  },

  isValidPastMissionBegin: function(limit, beginAt) {
    return this.getNextLimitDate(limit, beginAt).isAfter(moment());
  },

  getDictionaryFromArrayAndId: function(array, id, key) {
    if (!key) {
      key = "id";
    }

    var result = {};
    if (!array) {
      return result;
    }

    var length = array.length;
    for (var i = 0; i < length; i++) {
      if (array[i] && array[i][key] != undefined) {
        result[array[i][key]] = array[i];
      }
    }
    return result;
  },

  getObjectFromArrayAndId: function(array, id, key) {
    if (!key) {
      key = "id";
    }

    if (!array) {
      return null;
    }

    var length = array.length;
    for (var i = 0; i < length; i++) {
      if (array[i][key] == id) {
        return array[i];
      }
    }
    return null;
  },

  getArrayObjectFromArrayAndArrayId: function(array, ids, key) {
    if (!key) {
      key = "id";
    }

    var result = [];
    if (!array) {
      return result;
    }

    var length = array.length;
    for (var i = 0; i < length; i++) {
      if (ids.indexOf(array[i][key]) != -1) {
        result.push(array[i]);
      }
    }
    return result;
  },

  getArrayIdsFromArrayObjects: function(array, key) {
    if (!key) {
      key = "id";
    }

    var ids = [];
    if (!array) {
      return ids;
    }

    var length = array.length;
    for (var i = 0; i < length; i++) {
      if (array[i] && array[i][key] != undefined) {
        ids.push(array[i][key]);
      }
    }
    return ids;
  },

  getInfoOnWorkerInInstitution: function(controller, idInstitution, callbackSuccess) {
    Utils.csfrAjax({
      url: "/infoOnWorker/getFromInstitution",
      dataType: "json",
      type: "POST",
      data: {
        idInstitution: idInstitution
      },
      success: function(infoOnWorkerInInstitutions) {
        callbackSuccess(infoOnWorkerInInstitutions);
      }.bind(controller),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, controller);
      }.bind(controller)
    });
  },

  getInfoOnWorkerInInstitution_has_Worker: function(controller, idInstitution, idWorker) {
    Utils.csfrAjax({
      url: "/infoOnWorker/getFromInstitutionWorker",
      dataType: "json",
      type: "POST",
      data: {
        idInstitution: idInstitution,
        idWorker: idWorker
      },
      success: function(infoOnWorkerInInstitution_has_Workers) {
        InfoOnWorkerActionsCreator.editInfoOnWorkerInInstitution_has_Worker(
          infoOnWorkerInInstitution_has_Workers,
          idInstitution,
          idWorker
        );
      }.bind(controller),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, controller);
      }.bind(controller)
    });
  },

  getSlots: async function(controller, fromMoment, toMoment, workerId, whichMoment, shouldRemove) {
    try {
      var fromDate = new Date(Date.UTC(fromMoment.year(), fromMoment.month(), fromMoment.date()));
      var toDate = new Date(Date.UTC(toMoment.year(), toMoment.month(), toMoment.date()));

      var _data = {
        fromDate: fromMoment.format("YYYY-MM-DD"),
        toDate: toMoment.format("YYYY-MM-DD"),
        workerId: workerId
      };
      let data = await Utils.request("/slots/get", "POST", _data);
      SlotsActionsCreator.editSlots({
        slots: data,
        whichSlide: -1,
        whichMoment: whichMoment,
        shouldRemove: shouldRemove
      });
      return data;
    } catch (xhr) {
      console.error(xhr);
      Utils.displayError(xhr.responseText, controller);
    }
  },

  getVacationFromId: function(container, idMission) {
    if (idMission) {
      Utils.csfrAjax({
        url: "/v2/vacation/get",
        dataType: "json",
        type: "POST",
        data: {
          idMission: idMission
        },
        success: function(mission) {
          MissionActionsCreator.editMission(mission);
        }.bind(container),
        error: function(xhr, status, err) {
          console.error(err);
          console.error(xhr);
          Utils.displayError(xhr.responseText, container);
        }.bind(container)
      });
    }
  },

  getCredits: function(container, idInstitution) {
    if (idInstitution) {
      Utils.csfrAjax({
        url: "/credit/get",
        dataType: "json",
        type: "POST",
        data: {
          idInstitution: idInstitution
        },
        success: function(credits) {
          Utils.log("get credits");
          Utils.log(credits);
          CreditActionsCreator.editCredits(credits);
        }.bind(container),
        error: function(xhr, status, err) {
          console.error(err);
          console.error(xhr);
          Utils.displayError(xhr.responseText, container);
        }.bind(container)
      });
    }
  },

  editListToBeAddressedWorkers: function(controller, _data) {
    Utils.csfrAjax({
      url: "/v2/institution_has_worker/getToBeAddressedWorkers",
      dataType: "json",
      type: "POST",
      data: _data,
      success: function(result) {
        if (_data.isSearch) {
          WorkersActionsCreator.editToBeAddressedWorkersFromSearch(result);
        } else {
          WorkersActionsCreator.editToBeAddressedWorkers(result);
        }
      }.bind(controller),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, controller);
      }.bind(controller)
    });
  },

  editListWorkers: function(controller, _data) {
    if (!_data) {
      _data = {};
    }

    Utils.csfrAjax({
      url: "/v2/institution_has_worker/getWorkers",
      dataType: "json",
      type: "POST",
      data: _data,
      success: function(result) {
        if (_data.isSearch) {
          WorkersActionsCreator.editWorkersFromSearch(result);
        } else {
          WorkersActionsCreator.editWorkers(result);
        }
      }.bind(controller),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, controller);
      }.bind(controller)
    });
  },

  editListInvitedWorkers: function(controller, _data) {
    if (!_data) {
      _data = {};
    }

    Utils.csfrAjax({
      url: "/api/v1/institutionInvitationWorkers/getInvitations",
      dataType: "json",
      type: "POST",
      data: _data,
      success: function(result) {
        if (_data.isSearch) {
          WorkersActionsCreator.editInvitedWorkersFromSearch(result);
        } else {
          WorkersActionsCreator.editInvitedWorkers(result);
        }
      }.bind(controller),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, controller);
      }.bind(controller)
    });
  },

  displayError: function(errorMessage, controller) {
    if (controller) {
      controller.setState({
        errorMessage: errorMessage,
        infoMessage: "",
        isSpinnerInfoMessage: false
      });
    }
  },

  displayInfo: function(infoMessage, controller, isSpinner) {
    var newState = {
      errorMessage: "",
      infoMessage: infoMessage
    };
    if (isSpinner) {
      newState["isSpinnerInfoMessage"] = true;
    } else {
      newState["isSpinnerInfoMessage"] = false;
    }
    if (controller) {
      controller.setState(newState);
    }
  },

  getUserProfile: function(controller) {
    Utils.csfrAjax({
      url: "/v2/worker/getProfile",
      dataType: "json",
      type: "GET",
      success: function(data) {
        UserActionsCreator.editProfileUser(data);
      }.bind(controller),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, controller);
      }.bind(controller)
    });
  },

  updateMissions: function(container) {
    Utils.csfrAjax({
      url: "/v2/user/vacations/get",
      dataType: "json",
      type: "GET",
      success: function(data) {
        UserMissionsActionsCreator.editMissions(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  updateMyMissions: function(container, _data) {
    Utils.csfrAjax({
      url: "/v2/user/vacations/getMine",
      dataType: "json",
      type: "POST",
      data: _data,
      success: function(data) {
        UserMissionsActionsCreator.editMyMissions(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  updateMyMissionsHistory: function(container, _data) {
    Utils.csfrAjax({
      url: "/v2/user/vacations/getMineHistory",
      dataType: "json",
      type: "POST",
      data: _data,
      success: function(data) {
        UserMissionsActionsCreator.editMyMissionsHistory(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  getWorkerMissionById: function(container, _data, callbackSuccess) {
    if (!_data) {
      _data = {};
    }

    Utils.csfrAjax({
      url: "/v2/user/mission/get",
      dataType: "json",
      type: "POST",
      data: _data,
      success: function(data) {
        callbackSuccess(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        var errMessage = !xhr.responseText ? "Pas de connexion Internet" : xhr.responseText;
        Utils.displayError(errMessage, container);
      }.bind(container)
    });
  },

  updateMissionsFromAdmin: function(container, params, callbackSuccess) {
    if (!params) {
      params = {};
    }

    var url = StringUtils.getGETUrlFromPOSTUrlParam("/v2/admin/institutions/missions", params);

    Utils.csfrAjax({
      url: url,
      dataType: "json",
      type: "GET",
      success: function(data) {
        callbackSuccess(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  updateMissionRequestsFromAdmin: function(container, _data, callbackSuccess) {
    if (!_data) {
      _data = {};
    }
    Utils.csfrAjax({
      url: "/v2/missionRequest/getMine",
      dataType: "json",
      type: "POST",
      data: _data,
      success: function(data) {
        //Utils.log("result");
        //Utils.log(data);
        callbackSuccess(data);
      }.bind(container),
      error: function(xhr, status, err) {
        if (xhr.status !== 403) {
          console.error(err);
          console.error(xhr);
          Utils.displayError(xhr.responseText, container);
        } else {
          callbackSuccess([]);
        }
      }.bind(container)
    });
  },

  getNbRequestWaiting: function(container, callbackSuccess) {
    Utils.csfrAjax({
      url: "/v2/missionRequest/count",
      dataType: "json",
      type: "GET",
      success: function(data) {
        //Utils.log("result");
        //Utils.log(data);
        callbackSuccess(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  removeDuplicateInArray: function(array) {
    var result = [];
    if (!array) {
      return result;
    }

    var dict = {};
    var length = array.length;
    for (var i = 0; i < length; i++) {
      if (!dict[array[i]]) {
        result.push(array[i]);
        dict[array[i]] = 1;
      }
    }

    return result;
  },

  removeDuplicateInDictionary: function(array, key) {
    var result = [];
    if (!array) {
      return result;
    }

    if (!key) {
      key = "id";
    }

    var dict = {};
    var length = array.length;
    for (var i = 0; i < length; i++) {
      if (array[i][key]) {
        if (!dict[array[i][key]]) {
          result.push(array[i]);
          dict[array[i][key]] = 1;
        }
      }
    }

    return result;
  },

  getNbWorkedHoursInWindowForMissionsString: function(missions, date, type) {
    var measureBegin;
    var measureEnd;
    var periodName;
    var hours = 0;
    if (type == "month") {
      measureBegin = moment(date).startOf("month");
      measureEnd = moment(date).endOf("month");
      periodName = "en " + moment(date).format("MMMM");
    } else if (type == "year") {
      measureBegin = moment(date).startOf("year");
      measureEnd = moment(date).endOf("year");
      periodName = "en " + moment(date).format("YYYY");
    }

    for (var i in missions) {
      var m = missions[i];
      /*
		//the exact way
		var min = (measureBegin.isAfter(moment(m.beginAt))?measureBegin:moment(m.beginAt));
		var max = (measureEnd.isBefore(moment(m.endAt))?measureEnd:moment(m.endAt));
		hours += max.diff(min, "hours", true);*/
      if (moment(m.beginAt).isAfter(measureBegin) && moment(m.beginAt).isBefore(measureEnd)) {
        if (m.nbWorkedMinutes) {
          hours += m.nbWorkedMinutes / 60;
        } else {
          hours += moment(m.endAt).diff(moment(m.beginAt), "hours", true);
        }
      }
    }

    var nbHour = Math.round(hours);
    var result = nbHour + " heure".addS(nbHour) + " " + "attribuée".addS(nbHour) + " " + periodName;

    return result;
  },

  getProfilePictureFromWorker: function(container) {
    Utils.csfrAjax({
      url: "/worker/profilePicture",
      dataType: "json",
      type: "GET",
      success: function(data) {
        UserDocumentsActionsCreator.setProfilePicture(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  getDocumentFromWorker: function(type, idWorker) {
    return Utils.request("/worker/document", "GET", {
      documentType: type,
      idWorker: idWorker
    });
  },

  getInstitution_has_WorkerFromWorker: function(container, _idInstitution) {
    var data = {};
    if (_idInstitution) {
      data = {
        idInstitution: _idInstitution
      };
    }
    Utils.csfrAjax({
      url: "/v2/institution_has_worker/getInstitution_has_WorkerFromWorker",
      dataType: "json",
      type: "POST",
      data: data,
      success: function(data) {
        Institution_has_WorkerActionsCreator.editInstitution_has_Workers(data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  getSchedules: function(container, idInstitution) {
    Utils.csfrAjax({
      url: "/schedules/get",
      dataType: "json",
      type: "POST",
      data: {
        idInstitution: idInstitution
      },
      success: function(data) {
        Utils.log("2");
        Utils.log(data);
        ScheduleActionsCreator.edit(
          data.sort(
            (a, b) =>
              moment.utc(a.beginAt).get("hour") > moment.utc(b.beginAt).get("hour") ? 1 : -1
          )
        );
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        Utils.displayError(xhr.responseText, container);
      }.bind(container)
    });
  },

  getInstitutionCrisisWorkerFromWorker: function(container, idWorker, callback) {
    Utils.csfrAjax({
      url: "/institutionCrisisWorker/getFromWorker",
      dataType: "json",
      type: "POST",
      data: {
        idWorker: idWorker
      },
      success: function(institution_crisis_worker) {
        callback(null, institution_crisis_worker);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        callback(xhr.responseText);
      }.bind(container)
    });
  },

  getInstitutionOptions: function(container, callback) {
    Utils.csfrAjax({
      url: "/institutionOptions/get",
      dataType: "json",
      type: "GET",
      success: function(_data) {
        callback(null, _data);
      }.bind(container),
      error: function(xhr, status, err) {
        console.error(err);
        console.error(xhr);
        callback(xhr.responseText, null);
      }.bind(container)
    });
  },

  getCloudinaryFolder: function(worker) {
    return worker.id + "_vacataire";
  },

  getBreakTimeFromBeginAtEndAtNbWorkedMinutes: function(
    beginAtMoment,
    endAtMoment,
    nbWorkedMinutes
  ) {
    var breakTime = endAtMoment.diff(beginAtMoment, "minutes") - nbWorkedMinutes;
    return breakTime > 0 ? breakTime : 0;
  },

  getNbWorkedMinutesFromBeginAtEndAtBreakTime: function(beginAtMoment, endAtMoment, breakTime) {
    var nbWorkedMinutes = endAtMoment.diff(beginAtMoment, "minutes") - breakTime;
    return nbWorkedMinutes;
  },

  getBreakTimeOptions: function() {
    var hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    var minutes = [];
    var iString;
    for (var i = 0; i <= 9; i++) {
      minutes.push("0" + i);
    }
    for (var i = 10; i <= 59; i++) {
      minutes.push(i.toString());
    }
    var numberWorkedHoursOptions = [];
    for (var i = 0; i < hours.length; i++) {
      for (var j = 0; j < minutes.length; j++) {
        numberWorkedHoursOptions.push({
          value: parseInt(hours[i] * 60 + parseInt(minutes[j])).toString(),
          label: hours[i] + "h" + minutes[j]
        });
      }
    }

    return numberWorkedHoursOptions;
  },

  getEndAtFromBeginAtNumberWorkedHours: function(beginAtMoment, numberWorkedHours) {
    var endAtMoment = beginAtMoment.clone();

    if (numberWorkedHours) {
      var numberWorkedHoursArray = numberWorkedHours.split(":");
      if (numberWorkedHoursArray && numberWorkedHoursArray.length == 2) {
        endAtMoment = endAtMoment.add(numberWorkedHoursArray[0], "hours");
        endAtMoment = endAtMoment.add(numberWorkedHoursArray[1], "minutes");
      }
    }

    return endAtMoment;
  },

  //AJAX
  csfrAjax: function(_dictionaryAjax) {
    var _csrf = _dictionaryAjax["_csrf"];
    var dictionaryAjax = _dictionaryAjax;
    delete dictionaryAjax["_csrf"];

    var newDictionaryAjax = dictionaryAjax;
    var url = newDictionaryAjax["url"];
    switch (url) {
      case "/worker/profilePicture":
        newDictionaryAjax["cache"] = true;
        break;

      default:
        newDictionaryAjax["cache"] = false;
        break;
    }

    $.ajax(newDictionaryAjax);
  },

  log: function(message) {
    if (
      window.location.hostname == "medgo.fr" ||
      window.location.hostname == "www.medgo.fr" ||
      window.location.hostname == "medgobeta.herokuapp.com" ||
      window.location.hostname == "www.medgobeta.herokuapp.com"
    ) {
    } else {
      console.log(message);
    }
  },
  request(url, method, data) {
    return new Promise((resolve, reject) => {
      Utils.csfrAjax({
        url,
        dataType: "json",
        type: method,
        data,
        success: function(_data) {
          resolve(_data);
        },
        error: function(xhr, status, err) {
          reject(xhr);
        }
      });
    });
  },
  getTitleFromUrl(url) {
    let splitedUrl = url.split("/");
    return splitedUrl[splitedUrl.length - 1];
  },
  isValidPlace(place) {
    return !place || !place.address_components || place.address_components.length == 0;
  }
};

module.exports = Utils;



// WEBPACK FOOTER //
// ./assets/react/utils/Utils.js